<!-- Announcement -->
@if (announcement?.message) {
  <announcement-bar [announcement]="announcement"></announcement-bar>
}

<div class="main-container layout-section mb-80">
  <!-- ssr loader -->
  @if (ssrLoader) {
    <div class="non-absolute-loader">
      <base-loader-dot></base-loader-dot>
    </div>
  }

  <!-- loader -->
  @if (loading()) {
    <div class="non-absolute-loader">
      <base-loader-dot></base-loader-dot>
    </div>
  }
  @if (categoryName) {
    <div class="home-section">
      @for (home_content_section of categoryBanners; track home_content_section?.type) {
        @switch (home_content_section.type) {
          @case (HomeContentType.BANNER) {
            @if (home_content_section?.layout === 1 || (home_content_section?.layout !== 10 && isMobile())) {
              @if (
                home_content_section?.type === HomeContentType.BANNER &&
                home_content_section?.state === PublishStatus.published &&
                home_content_section?.banner_sections
              ) {
                <webstore-banner-carousel [banners]="home_content_section.banner_sections"> </webstore-banner-carousel>
              }
            } @else {
              @if (home_content_section?.state === PublishStatus.published) {
                <banner-layouts [home_content_section]="home_content_section"></banner-layouts>
              }
            }
          }
        }
      }
    </div>
  }
  @if (productSearch(); as products) {
    <!-- displaying here for desktop version category horizontal banner -->
    @if (products?.hits?.total?.value && +products.hits.total.value > 0) {
      <div class="d-none d-sm-none d-md-none d-lg-block d-xl-block d-xxl-block">
        @if (isMobile() && categoryMobileTopBanner) {
          <div class="row text-center">
            <div
              class="category-horizontal-banner p-0 mt-3 mt-sm-3 mt-md-3 mt-lg-0 mt-xl-0 mb-3 mb-sm-3 mb-md-3 mb-lg-4 mb-xl-4"
            >
              <img [src]="categoryMobileTopBanner" class="category-banner-img img-fluid" />
            </div>
          </div>
        }
        @if (!isMobile() && categoryWebTopBanner) {
          <div class="row text-center">
            <div
              class="category-horizontal-banner p-0 mt-3 mt-sm-3 mt-md-3 mt-lg-0 mt-xl-0 mb-3 mb-sm-3 mb-md-3 mb-lg-4 mb-xl-4"
            >
              <img [src]="categoryWebTopBanner" class="category-banner-img img-fluid" />
            </div>
          </div>
        }
      </div>
    }
    @if (isBrowser) {
      <!--reused for search and category-->
      <!-- Product search header section (category + sort dropdown)-->
      @if (sectionConfiguration.show_filters && sectionConfiguration.show_product_list) {
        <div class="sorting-section mt-20">
          <div class="row justify-content-end">
            <div class="col-12 col-sm-12 col-md-12 col-lg-10">
              <!-- category section -->
              @if (!isSearching && !isViewingProducts) {
                <nav class="breadcrumb-navigation">
                  <ul>
                    @for (breadcrumb of breadcrumbDataComputed(); track breadcrumb.id) {
                      <li>
                        <a
                          [class.breadcrumb-active]="breadcrumb.id === selectedCategoryIdComputed()"
                          [routerLink]="['/category', breadcrumb.url]"
                          >{{ breadcrumb.name }}
                        </a>
                      </li>
                    }
                  </ul>
                </nav>
              }

              <!-- Brand section -->
              @if (isSearchingBrandProducts) {
                @if (brandName(); as brandName) {
                  <div class="heading-section">
                    <h1>{{ brandName }}</h1>
                  </div>
                }
              }

              <!-- Page Title -->
              @if (isViewingProductCollection) {
                @if (collectionTitle(); as collectionTitle) {
                  <div class="heading-section">
                    <h1>{{ collectionTitle }}</h1>
                  </div>
                }
              }

              <!-- Search results -->
              @if (isSearching && products?.hits?.total?.value && +products.hits.total.value) {
                <!-- Switch container for queryParams-->
                @switch (!!route.snapshot.queryParams.q) {
                  @case (true) {
                    <div class="search-result-section">
                      <p class="search-result-heading mb-6">search results for:</p>
                      <div
                        class="d-flex flex-column flex-sm-column flex-md-row flex-lg-row flex-xl-row justify-content-start align-items-start align-items-sm-start align-items-md-center align-items-lg-center align-items-xl-center"
                      >
                        <p class="product-search-item mr-15">
                          {{ route.snapshot.queryParams.q }}
                        </p>
                      </div>
                    </div>
                  }
                  @case (false) {
                    <div class="heading-section">
                      <h1>{{ route.snapshot.queryParams.tags ?? '' }}</h1>
                    </div>
                  }
                }
                @if (route.snapshot.queryParams; as queryParams) {
                  @if (queryParams.category_name_keyword) {
                    <div class="search-result-section">
                      <p class="search-result-heading mb-6">search results for:</p>
                      <div
                        class="d-flex flex-column flex-sm-column flex-md-row flex-lg-row flex-xl-row justify-content-start align-items-start align-items-sm-start align-items-md-center align-items-lg-center align-items-xl-center"
                      >
                        <p class="product-search-item mr-15">{{ queryParams.category_name_keyword }}</p>
                      </div>
                    </div>
                  }
                  @if (queryParams.display_name_keyword) {
                    <div class="search-result-section">
                      <p class="search-result-heading mb-6">search results for:</p>
                      <div
                        class="d-flex flex-column flex-sm-column flex-md-row flex-lg-row flex-xl-row justify-content-start align-items-start align-items-sm-start align-items-md-center align-items-lg-center align-items-xl-center"
                      >
                        <p class="product-search-item mr-15">{{ queryParams.display_name_keyword }}</p>
                      </div>
                    </div>
                  }
                  @if (queryParams.seo_detail_keyword) {
                    <div class="search-result-section">
                      <p class="search-result-heading mb-6">search results for:</p>
                      <div
                        class="d-flex flex-column flex-sm-column flex-md-row flex-lg-row flex-xl-row justify-content-start align-items-start align-items-sm-start align-items-md-center align-items-lg-center align-items-xl-center"
                      >
                        <p class="product-search-item mr-15">{{ queryParams.seo_detail_keyword }}</p>
                      </div>
                    </div>
                  }
                }
              }
            </div>

            <div class="col-12 col-sm-12 col-md-12 col-lg-2 p-0">
              @if (mediaQuery()) {
                <!-- this section is visible for desktop version devices and hidden for mobile version devices -->
                <div class="tools-section-desktop" [class.mb-30]="isMobile() && categoryMobileTopBanner">
                  <div class="d-block d-lg-none d-xl-none">
                    <label class="filter-counter" (click)="showFilters()"
                      >Filter: ({{ currentAppliedFilters()?.length || 0 }})
                    </label>
                  </div>
                  <div class="w-160">
                    <sort-dropdown [collapsedInput]="true" [control]="sortBy" [listInput]="sortByValue"></sort-dropdown>
                  </div>
                </div>
              } @else {
                <!-- this section is visible for mobile  version devices and hidden for desktop version devices -->
                <div class="tools-section-mobile">
                  <div class="left-section">
                    <label class="filter-counter" (click)="showFilters()"
                      >Filter: ({{ currentAppliedFilters()?.length || 0 }})</label
                    >
                  </div>
                  <div class="right-section">
                    <base-dropdown-mobile-filter
                      [controlInput]="sortBy"
                      [listInput]="sortByValue"
                    ></base-dropdown-mobile-filter>
                  </div>
                </div>
              }
            </div>
          </div>
        </div>
      }

      <!-- displaying here for mobile version category horizontal banner -->
      <div class="d-block d-sm-block d-md-block d-lg-none d-xl-none d-xxl-none">
        @if (isMobile() && categoryMobileTopBanner) {
          <div class="row text-center">
            <div class="category-horizontal-banner p-0 mb-3 mb-sm-3 mb-md-3 mb-lg-4 mb-xl-4">
              <img [src]="categoryMobileTopBanner" class="category-banner-img img-fluid" />
            </div>
          </div>
        }
        @if (!(isMobile() && categoryWebTopBanner)) {
          <div class="row text-center">
            <div
              class="category-horizontal-banner p-0 mt-3 mt-sm-3 mt-md-3 mt-lg-0 mt-xl-0 mb-3 mb-sm-3 mb-md-3 mb-lg-4 mb-xl-4"
            >
              <img [src]="categoryWebTopBanner" class="category-banner-img img-fluid" />
            </div>
          </div>
        }
      </div>

      <!--When search will return products-->
      @if (products?.hits?.total?.value && +products.hits.total.value > 0) {
        <div class="row">
          <!-- Filters -->
          <!-- TODO add slide and slide out after the button is clicked once only -->
          @if (sectionConfiguration.show_filters && sectionConfiguration.show_product_list) {
            <div class="col-12 col-sm-12 col-md-3 col-lg-3">
              <base-filters
                (close$)="hideFilters()"
                [ngClass]="{
                  'isMobile-filter-menu': !mediaQuery(),
                }"
                [filtersInput]="aggregationsValue"
              >
              </base-filters>

              <!-- category vertical banner -->
              <div class="category-vertical-banner text-center p-0 d-none d-sm-none d-md-none d-lg-block d-xl-block">
                <img [src]="categoryWebLeftBanner" class="category-banner-img img-fluid" />
              </div>
            </div>
          }

          <!-- Products View-->
          <div
            class="col-12 col-sm-12 col-md-12 col-lg-9"
            [ngClass]="{
              'col-lg-12 col-xl-12': !sectionConfiguration.show_filters,
            }"
          >
            <!-- filter-chips -->
            <!-- this section is visible for desktop version devices and hidden for mobile version devices -->
            @if (sectionConfiguration.show_filters && sectionConfiguration.show_product_list) {
              <div class="d-none d-sm-none d-md-none d-lg-block d-xl-block">
                <div class="mb-2 d-flex flex-wrap">
                  @for (filter of currentAppliedFilters(); track filter?.filter?.value) {
                    <filter-chip
                      [filterTitle]="filter.filter?.value || ''"
                      (removeFilter$)="removeFilter(filter.filter)"
                    ></filter-chip>
                  }
                </div>
              </div>
            }
            @if (sectionConfiguration.show_product_list && products?.hits?.hits) {
              <webstore-products [productsInput]="products.hits.hits"></webstore-products>
            }

            <!--product listing loader -->
            @if (listLoading()) {
              <base-listing-loader></base-listing-loader>
            }
          </div>
        </div>
      } @else {
        <div class="row">
          <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
            <div class="empty-product-state">
              <!-- Handle specific case for search and tag query -->
              @if (!!route.snapshot.queryParams.q) {
                <h2>
                  Search Results for:
                  <span class="search-item">{{ route.snapshot.queryParams.q ?? '' }}</span>
                </h2>
              } @else {
                <h2>{{ route.snapshot.queryParams.tags ?? '' }}</h2>
              }

              <p class="empty-state-msg">
                We're sorry, no products were found for your search:
                <span class="search-item">{{ route.snapshot.queryParams.q ?? '' }}</span>
              </p>
              <p class="empty-state-tips">Try your search again using these tips:</p>
              <ul class="tips-list">
                <li>Double check the spelling. Try varying the spelling.</li>
                <li>Limit the search to one or two words</li>
                <li>
                  Be less specific in your wording. Sometimes a more general term will lead you to the similar products.
                </li>
              </ul>
              <div class="row">
                <div class="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 p-0">
                  <base-empty-state-input></base-empty-state-input>
                </div>
              </div>
            </div>
          </div>
        </div>
      }
    }
  }
</div>
